<script>
import {ref} from "vue";
import StrImportModelSelect from "@/views/ImportModel/Components/StrImportModelSelect.vue";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "MorePrintAction",
    components: {StrImportModelSelect},
    props: {
        filter: Object,
    },
    setup(props) {


        const exportDialog = ref(false);
        const exportLoading = ref(false);
        const exportByModel = ref(false);
        const modelId = ref(null);
        const {transformFilterValues, exportPdf} = useSharedMethod();

        const annexStore = usePaySlipAnnexStore();

        function exportToExcel() {
            exportLoading.value = true;
            axios.get(`/printed/exportPaySlips`, {
                responseType: "arraybuffer",
                params: transformFilterValues({
                    ...props.filter,
                    modelId: modelId.value,
                    exportByModel: exportByModel.value,
                }),
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let index = annexStore.paySlipAnnexes.findIndex(e => e.id === props.filter.annexId);
                link.setAttribute("download", `${annexStore.paySlipAnnexes[index].name}.xlsx`);
                document.body.appendChild(link);
                link.click();
            }).finally(() => {
                exportLoading.value = false;
            });
        }

        function printEtatRecapitulatif() {
            exportPdf(`/printed/getEtatRecapitulatif/${props.filter.annexId}`)
        }

        return {
            exportDialog,
            exportLoading,
            exportByModel,
            modelId,
            exportToExcel,
            printEtatRecapitulatif,
        }
    }
}
</script>

<template>
    <div>
        <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    small
                    color="primary"
                    depressed
                    dark
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ $t('pay_slip.impression') }}
                    <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item @click="exportDialog = true">
                    <v-list-item-icon>
                        <v-icon>mdi-file-export</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ $t("common.export") }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    @click="$router.push({name: 'pay_slips.print',params: {annexId: filter.annexId}})"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('pay_slip.bulletin') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    @click="$router.push({name: 'pay_slips.journal',params: {annexId: filter.annexId}})"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('pay_slip.journal') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    @click="printEtatRecapitulatif"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-sigma</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('pay_slip.summary_report') }}</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu>
        <v-dialog
            v-model="exportDialog"
            persistent
            max-width="600"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.export')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <v-radio-group v-model="exportByModel">
                                    <v-radio :value="false" :label="$t('pay_slip.default_export')"></v-radio>
                                    <v-radio :value="true" :label="$t('pay_slip.modal_export')"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col
                                v-if="exportByModel"
                                cols="12"
                            >
                                <w-label :label="$t('common.label')" required/>
                                <str-import-model-select
                                    v-model="modelId"
                                    :type="'PAY'"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="exportDialog = false"/>
                    <w-btn-export
                        :loading="exportLoading"
                        @press="exportToExcel"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>